var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeDarker20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "467F82F9-25D8-4BF4-9DE9-330FFBAC874F_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Krediitkaart",
    transform: "translate(-1062.000000, -101.000000)",
    stroke: "#DD9C00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(208.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(451.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(404.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Time_Darker_20px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C20,15.5228478 15.5228478,20 10,20 C4.47715217,20 0,15.5228478 0,10 C0,4.47715217 4.47715217,0 10,0 C15.5228478,0 20,4.47715217 20,10 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "10.4347826 2.60869565 10.4347826 10.4347826 5.2173913 10.4347826"
  })))))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeDarker20Px);
export default __webpack_public_path__ + "static/media/Icon_Time_Darker_20px.91d6bd865eb0f63b9d6c78ecc6ac6904.svg";
export { ForwardRef as ReactComponent };